import { SelectOption } from "@velaro/velaro-component-lib";
import React from "react";

export interface Site {
  siteId: number;
  id?: number; // Deprecated: Backend returns siteId, kept for backwards compatibility during migration
  companyName: string;
  // ✅ NEW FIELDS FROM BACKEND
  companyURL?: string;
  companyAddress1?: string;
  companyAddress2?: string;
  companyPostalCode?: string;
  companyCountryID?: number;
  region?: string;
  language?: string;
  timezone?: string;
  comments?: string;
  phoneNumber?: string;
  city?: string;
  dataDisclosureText?: string;
  logoUrl?: string;
  dateCreated?: string;
  // 🔧 SYSTEM FIELDS (read-only)
  createdByUserId?: number;
  extraInfo?: string;
  subscrioKey?: string;
  apiKey?: string;
  gaid?: string;   // legacy — may be returned as gAID by ASP.NET camelCase
  gAID?: string;   // Google Analytics Measurement ID (GA4: G-XXXXXXXXXX)
  isTestSite?: boolean;
  canOnlySeeNewUserInterface?: boolean;
}

export interface ToastAlertSettings {
  stickyAlerts: boolean;
  stickyDuration: number;
}

export interface MenuItem {
  label: string;
  to?: string;
  icon: any;
  sublinks?: SubLink[];
  enabled?: boolean;
}

export interface SubLink {
  label: string;
  to: string;
  enabled?: boolean;
}

export type SvgIcon = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
  }
>;

export interface TimeZone {
  id: string;
  displayName: string;
}

export const channelDefs = {
  web: "Web",
  facebook: "Facebook",
  twitter: "Twitter",
  email: "Email",
  whatsApp: "WhatsApp",
  twilioIvr: "IVR",
  twilioSms: "SMS",
  rcs: "RCS"
};
export type Channel = keyof typeof channelDefs;
export const channelOptions: SelectOption[] = Object.keys(channelDefs).map(
  (key: string) => {
    return {
      label: channelDefs[key as Channel],
      value: key
    };
  }
);

export const dayOfWeekDefs = {
  mon: "Monday",
  tues: "Tuesday",
  wed: "Wednesday",
  thurs: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday"
};
export type DayOfWeek = keyof typeof dayOfWeekDefs;
export const dayOfWeekKeys = Object.keys(dayOfWeekDefs) as DayOfWeek[];
